import React from 'react';

import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import ArrowIcon from './ArrowIcon';
import AllBreakoutRoomsContainer from '../../context/AllBreakoutRoomsContext';

const Arrow = styled.div`
    position: absolute;
    top: calc(50% - ${32 / 2}px);
    color: rgb(70, 70, 70);
    cursor: pointer;

    &:hover {
        color: ${(props) => props.theme.colors.primary.main};
    }

    svg {
        width: 32px;
    }
`;

const ArrowLeft = styled(Arrow)`
    left: 0;

    svg {
        transform: rotate(90deg);
    }
`;

const ArrowRight = styled(Arrow)`
    right: 0;

    svg {
        transform: rotate(-90deg);
    }
`;

const PageCount = styled.div`
    color: ${(props) => props.theme.colors.white};
    position: absolute;
    left: 0;
    bottom: 5px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Navigation = () => {
    const { currentPage, setCurrentPage, totalPages } = useContainer(AllBreakoutRoomsContainer);

    const nextPage = () => {
        setCurrentPage(Math.max(currentPage - 1, 1));
    };

    const prevPage = () => {
        setCurrentPage(Math.min(currentPage + 1, totalPages));
    };

    if (totalPages < 2) return null;

    return (
        <>
            {currentPage > 1 && (
                <ArrowLeft onClick={nextPage}>
                    <ArrowIcon />
                </ArrowLeft>
            )}
            {currentPage < totalPages && (
                <ArrowRight onClick={prevPage}>
                    <ArrowIcon />
                </ArrowRight>
            )}
            <PageCount>
                <span>
                    {currentPage} / {totalPages}
                </span>
            </PageCount>
        </>
    );
};

export default Navigation;
